<div class="unauth-right-header">
  <img src="assets/images/complydome-logo.png" class="unauth-mobile-logo" alt="ComplyDome">
  <a routerLink="/login">← Back to Sign In</a>
</div>

<main class="unauth-form-area">
  <div class="unauth-card">

    <div class="unauth-confirm-icon">
      <i class="fas fa-envelope-open-text"></i>
    </div>

    <h2>Check Your Email</h2>

    <div class="unauth-security-badge">
      <span class="unauth-security-dot"></span>
      Reset Link Sent
    </div>

    <p class="unauth-mfa-hint">
      We've sent a password reset link to your inbox. The link will expire in:
    </p>

    <div class="unauth-timer">
      {{ minutes }}:{{ seconds | number:'2.0-0' }}
    </div>

    <div class="unauth-forgot">
      <a routerLink="/login">Return to Sign In</a>
    </div>

  </div>
</main>
